module.exports = __webpack_public_path__ + "img/tp2.7e9aa0ba.png";